
import { combineReducers } from 'redux';
import authReducer from "./reducers/slices/authSlice";
import adminReducer from "./reducers/slices/adminSlice";
import propertyReducer from "./reducers/slices/propertySlice";
import propertyCommentReducer from "./reducers/slices/propertyCommentSlice";
import bookingReducer from "./reducers/slices/bookingSlice";
import  notificationReducer  from "./reducers/slices/notificationSlice";
import dealRoomReducer from "./reducers/slices/dealRoomSlice";
import waitingListReducer from "./reducers/slices/waitingListSlice";
import agencyAgreementReducer from "./reducers/slices/agencyAgreementSlice";
import landlordReducer from "./reducers/slices/landlordSlice";
import buyerReducer from "./reducers/slices/buyerSlice";
import tenantReducer from "./reducers/slices/tenantSlice";
import agentReducer from "./reducers/slices/agentSlice";
import lawyerReducer from "./reducers/slices/lawyerSlice";
import valuerReducer from "./reducers/slices/valuerSlice";

import { AuthState } from './reducers/slices/authSlice';
import { AdminState } from './reducers/slices/adminSlice';
import { PropertyState } from './reducers/slices/propertySlice';
import { CommentState } from './reducers/slices/propertyCommentSlice';
import { BookingState } from './reducers/slices/bookingSlice';
import { NotificationState } from './reducers/types/notification';
import { DealRoomState } from './reducers/slices/dealRoomSlice';
import { RoleSliceState } from './reducers/slices/roleSliceFactory';
import { AgencyAgreementState } from './reducers/types/agencyAgreement';

interface RootState {
   auth: AuthState;
   admin: AdminState;
   property: PropertyState;
   propertyComment: CommentState;
   booking: BookingState;
   notification: NotificationState;
   dealroom: DealRoomState;
   landlord: RoleSliceState;
   buyer: RoleSliceState;
   tenant: RoleSliceState;
   agent: RoleSliceState;
   lawyer: RoleSliceState;
   valuer: RoleSliceState;
   agencyAgreement: AgencyAgreementState;
}

const rootReducer = combineReducers({
   auth: authReducer,
   admin: adminReducer,
   property: propertyReducer,
   propertyComment: propertyCommentReducer,
   booking: bookingReducer,
   notification: notificationReducer,
   dealroom: dealRoomReducer,
    waitingList: waitingListReducer,
    landlord: landlordReducer,
    buyer: buyerReducer,
    tenant: tenantReducer,
    agent: agentReducer,
    lawyer: lawyerReducer,
    valuer: valuerReducer,
    agencyAgreement: agencyAgreementReducer,
});

export default rootReducer;
export type { RootState };
